/**
 * F4 맵 에디터. 현재 맵의 발판 JSON 을 고치고 적용한다.
 */

import { MAPS, TIER, FIRST_MAP, FIRST_SPAWN, type MapDef } from '../data/maps';
import { emitDataReloadSoon } from '../data/catalog';
import { REG } from '../scenes/BootScene';
import type { PlayerState } from '../systems/PlayerState';
import { focusAfterKey } from './focusAfterKey';
import type Phaser from 'phaser';

export const MapEditorOverlay = {
  blocking: false,

  bind(game: Phaser.Game): void {
    const dock = document.getElementById('map-dock');
    const area = document.getElementById('map-json') as HTMLTextAreaElement | null;
    const err = document.getElementById('map-error');
    if (!dock || !area || !err) return;

    const hide = (): void => {
      dock.hidden = true;
      MapEditorOverlay.blocking = false;
      err.textContent = '';
    };

    const currentMap = (): MapDef | undefined => {
      const state = game.registry.get(REG.state) as PlayerState | undefined;
      const id = state?.mapId || FIRST_MAP;
      return MAPS[id];
    };

    const load = (): void => {
      const map = currentMap();
      if (!map) return;
      area.value = JSON.stringify(
        { id: map.id, platforms: map.platforms, climbables: map.climbables },
        null,
        2,
      );
      err.textContent = '';
    };

    document.getElementById('map-close')?.addEventListener('click', hide);
    document.getElementById('map-load')?.addEventListener('click', load);
    document.getElementById('map-apply')?.addEventListener('click', () => {
      try {
        const parsed = JSON.parse(area.value) as { id?: string; platforms?: unknown; climbables?: unknown };
        const map = currentMap();
        if (!map) throw new Error('맵이 없습니다');
        if (!Array.isArray(parsed.platforms)) throw new Error('platforms 배열이 필요합니다');
        Object.assign(map, {
          platforms: parsed.platforms,
          climbables: Array.isArray(parsed.climbables) ? parsed.climbables : map.climbables,
        });
        hide();
        emitDataReloadSoon();
      } catch (e) {
        err.textContent = e instanceof Error ? e.message : 'JSON 오류';
      }
    });
    document.getElementById('map-foot')?.addEventListener('click', () => {
      const play = game.scene.getScene('play') as Phaser.Scene & { player?: Phaser.GameObjects.Sprite };
      const p = play?.player;
      if (!p) {
        err.textContent = '플레이 중에만 발판을 넣을 수 있습니다';
        return;
      }
      const map = currentMap();
      if (!map) return;
      const platforms = [...map.platforms, { x: Math.round(p.x - 80), y: Math.round(p.y), w: 160 }];
      Object.assign(map, { platforms });
      load();
      err.textContent = '발판을 넣었습니다. 적용을 누르세요.';
    });
    document.getElementById('map-download')?.addEventListener('click', () => {
      const blob = new Blob(
        [JSON.stringify({ TIER, FIRST_MAP, FIRST_SPAWN, MAPS }, null, 2)],
        { type: 'application/json' },
      );
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'maps.json';
      a.click();
      URL.revokeObjectURL(a.href);
    });

    MapEditorOverlay.show = (): void => {
      MapEditorOverlay.blocking = true;
      dock.hidden = false;
      load();
      focusAfterKey(area);
    };
  },

  show(): void {
    /* bind 가 덮어쓴다 */
  },
};
